import { Pipe, PipeTransform } from '@angular/core';
import { FormErrorPipe } from 'shared-ui/pipes/form-error.pipe';

@Pipe({
  name: 'fieldError',
  standalone: false,
})
export class FieldErrorPipe extends FormErrorPipe implements PipeTransform {}
